<template>
  <div>
    <div class="page-search-block">
      <el-button type="primary" @click="backToBell">返回</el-button>
      <span class="m-l-20 bold">门铃编码：{{ deviceCode }}</span>
      <span class="m-l-20 bold">房源名称：{{ roomName }}</span>
    </div>

    <div class="page-operate-block">
      <span class="page-title font-20 bold">门铃抓拍记录</span>
    </div>

    <div v-if="imgsData.length" class="table-list-block doorbell-img-content">
      <div class="page-title">点击抓拍图片可查看大图</div>
      <div class="imgs-container">
        <div class="content-item" v-for="item in imgsData" :key="item.id">
          <div class="img-line">
            <div class="img-item">
              <el-image class="img" :src="item.faceUrl" fit="cover" :preview-src-list="[item.faceUrl]">
              </el-image>
              <span>人脸照片</span>
            </div>
            <div class="img-item">
              <el-image class="img" :src="item.faceBgUrl" fit="cover" :preview-src-list="[item.faceBgUrl]">
              </el-image>
              <span>背景照片</span>
            </div>
          </div>
          <span class="img-desc">抓拍时间：{{ item.captureTime }}</span>
        </div>
        <div class="ghost-item" v-for="i in 4" :key="'g_' + i"></div>
      </div>
      <RPagination class="img-pagination" :pagination="pagination" @current-change="handlePageChange" />
    </div>
    <div v-else class="table-list-block empty-text">
      暂无抓拍图片
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import RPagination from '@/components/common/RPagination'

export default {
  name: 'equipDoorbellLogPage',
  components: { RPagination },
  props: {
    deviceCode: { type: [String, Number], default: '' },
    roomName: { type: String, default: '--' }
  },
  data() {
    return {
      imgsData: [],
      pagination: {
        pageIndex: 1,
        pageSize: 20,
        total: 0
      }
    }
  },
  created() {
    this.getQuery()
  },
  methods: {
    ...mapActions(['fetchData']),
    // 查询列表数据
    getQuery() {
      let params = {
        deviceCode: this.deviceCode,
        pageNumber: this.pagination.pageIndex,
        pageSize: this.pagination.pageSize,
      }
      let url = 'DEVICE.GET_CAPTURE_LIST'
      this.fetchData({ url, method: 'get', params }).then((res) => {
        this.imgsData = res.data || []
        this.pagination.total = res ? res.rowCount : 0
      })
    },
    // 返回
    backToBell() {
      this.$emit('change-view')
    },
    // 页码组件数据变动
    handlePageChange(index, size) {
      this.pagination.pageIndex = index
      this.pagination.pageSize = size
      this.getQuery()
    }
  },
}
</script>

<style lang="less" scoped>
@defaultColor: #909399;
@itemWidth: 270px;

.page-operate-block {
  text-align: unset !important;
}
.doorbell-img-content {
  position: relative;
  padding: 10px 40px;
  width: 100%;
  font-size: 14px;
  .page-title {
    margin-bottom: 10px;
    color: @defaultColor;
  }
  .img-pagination {
    padding: unset;
    width: calc(~"100% - 80px");
  }
  .imgs-container {
    min-height: 280px;
    max-height: calc(~"100vh - 190px");
    position: relative;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .content-item {
      position: relative;
      margin-bottom: 15px;
      padding: 10px 15px;
      width: @itemWidth;
      height: 170px;
      border: 1px solid #DCDFE6;
      border-radius: 2px;
    }
    .img-line {
      display: flex;
      align-content: center;
      justify-content: space-between;
    }
    .img-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      &:last-of-type {
        margin-left: 10px;
      }
      .img {
        width: 105px;
        height: 98px;
      }
      span {
        margin-top: 5px;
        margin-bottom: 5px;
        color: @defaultColor;
      }
    }
    .img-desc {
      color: @defaultColor;
    }
    .ghost-item {
      width: @itemWidth;
    }
  }
}
.empty-text {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 300px;
  font-size: 22px;
  color: @defaultColor;
}
</style>
